import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { BcAlertComponent } from '@bancolombia/design-system-web/bc-alert';
import { BcDialogService } from "@bancolombia/design-system-web/bc-services";
import { v4 as uuidv4 } from "uuid";

import { HttpResponse } from "@angular/common/http";
import { VfiscalGateway } from "../../models/validacion-fiscal/gateways/vfiscal.gateway";

@Injectable(
  {
      providedIn: 'root'
  }
)
export class VfiscalUseCase {
  constructor(private gateway: VfiscalGateway, private dialogService: BcDialogService) { }

  export(data?: string, option?: string): Observable<HttpResponse<Blob>> {
    return this.gateway.reporte();
  }

  descargarReporte(data: HttpResponse<Blob>, name: string = 'Facturas'): void {
    const fileName = `${name}-${uuidv4()}.csv`;

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(data.body!);
    link.download = fileName;
    link.click();
  }

  openAlert(type: string = 'success', title: string, message: string, timeout: number = 10000): void {
    const dialogRef = this.dialogService.open(BcAlertComponent, {
      id: 'MyAlertId',
      title: title,
      type: type,
      text: message,
      timeout: timeout,
    });

    dialogRef.onResult().subscribe(
      (closed) => { },
      (dismissed) => { },
      () => { }
    );
  }

}